// utils/testDomain.ts
import { api } from "../services/api";

const TEST_DOMAIN_KEY = "testDomain";
const DEFAULT_TEST_DOMAIN = "localhost";

// Synchronous read for use in render logic; falls back to "localhost"
// so behavior is unchanged until an admin saves a domain in Settings.
export const getCachedTestDomain = (): string => {
  return localStorage.getItem(TEST_DOMAIN_KEY) || DEFAULT_TEST_DOMAIN;
};

// Fetches the latest tester domain from the public settings endpoint
// and refreshes the local cache so future reads stay up to date.
export const refreshTestDomain = async (): Promise<string> => {
  try {
    const res = await api.get("/backend/settings/public-test-domain");
    const domain = res?.data?.testDomain?.trim();
    if (domain) {
      localStorage.setItem(TEST_DOMAIN_KEY, domain);
      return domain;
    }
  } catch (err) {
    // Silently keep the cached/default domain if the fetch fails
  }
  return getCachedTestDomain();
};
